import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./printWO.html",
})
export class PrintWorkOrder implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  printdata: any = {};
  matchData:any = [];
  wodata: any = {};
  @Input() set printdt(val: any[]) {
    this.printdata = val;
    console.log(this.printdata);
    this.printdata.wo_date = this.datePipe.transform(
      this.printdata.wo_date,
      "dd-MM-yyyy"
    );

    this.getDesignList(this.printdata.wo_id,this.printdata.wo_no);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private woservice: WorkOrderService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(wo_id,wo_no) {
    let params = {
      wo_id: wo_id,
      jobwo_no: wo_no
    };
    this.woservice.getEditDesignList(params).then((res: any) => {
      /*   res.data = res.data.concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data);  */

      let list = [],
        list2 = [],
        count = 0;
      for (let i = 0; i < res.data.length; i++) {
        const li = res.data[i];
        list2.push(li);
        count++;
        if (count >= 5) {
          list.push([].concat(list2));
          list2 = [];
          count = 0;
        }
      }
      if (list2.length) {
        list.push([].concat(list2));
      }
      this.list = list;
      // this.calcRate();
    
       let f36_tot = 0,
        f38_tot = 0,
        f40_tot = 0,
        f42_tot = 0,
        f44_tot = 0,
        f46_tot = 0,
        // h34_tot = 0,
        h36_tot = 0,
        h38_tot = 0,
        h40_tot = 0,
        h42_tot = 0,
        h44_tot = 0,
        h46_tot = 0;
       let total_mtr = 0;
      for (let i = 0; i < res.data.length; i++) {
        let des = res.data[i];
        // f34_tot += des.f34;
        f36_tot += des.f36;
        f38_tot += des.f38;
        f40_tot += des.f40;
        f42_tot += des.f42;
        f44_tot += des.f44;
        f46_tot += des.f46;
        // h34_tot += des.h34;
        h36_tot += des.h36;
        h38_tot += des.h38;
        h40_tot += des.h40;
        h42_tot += des.h42;
        h44_tot += des.h44;
        h46_tot += des.h46;
        total_mtr += des.mtr
  
        
      }
      // this.printdata["f34_tot"] = f34_tot;
      this.printdata["f36_tot"] = f36_tot;
      this.printdata["f38_tot"] = f38_tot;
      this.printdata["f40_tot"] = f40_tot;
      this.printdata["f42_tot"] = f42_tot;
      this.printdata["f44_tot"] = f44_tot;
      this.printdata["f46_tot"] = f46_tot;
      // this.printdata["h34_tot"] = h34_tot;
      this.printdata["h36_tot"] = h36_tot;
      this.printdata["h38_tot"] = h38_tot;
      this.printdata["h40_tot"] = h40_tot;
      this.printdata["h42_tot"] = h42_tot;
      this.printdata["h44_tot"] = h44_tot;
      this.printdata["h46_tot"] = h46_tot;
      this.printdata["total_mtr"] = total_mtr.toFixed(2);

      this.printdata["f_ratio"] = Number((this.printdata["fs_total"]/(this.printdata["tot_pcs"]) *100).toFixed(2));
      this.printdata["h_ratio"] = Number((this.printdata["hs_total"]/(this.printdata["tot_pcs"]) *100).toFixed(2));
      this.printdata["avg_con"] = Number(this.printdata["total_mtr"]/this.printdata["tot_pcs"]).toFixed(2);

      for (let i = 0; i < res.match.length; i++) {
        let a = res.match[i];
        this.matchData.push(a);
      }
      console.log("print data check",this.matchData);


    });
   
 
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/printWO.ts